<template>
  <div class="main-banner">
    <div class="banner-title">
      소상공인과 함께하는 <strong>2025 동행축제</strong>
    </div>
    <div class="banner-wrapper">
      <div
        v-if="banners && banners.length > 0"
        ref="bannerSwiper"
        :class="['swiper', 'banner-component', banners ? `banner-count-${banners.length}` : '']"
      >
        <!-- 슬라이드 내용 -->
        <div class="swiper-wrapper">
          <div v-for="(item, idx) in banners" :key="idx" class="swiper-slide">
            <component
              :is="
                isInternalRoute(item.mvmnptUrl, item.urlType)
                  ? 'router-link'
                  : (isPlaceholderExternal(item.mvmnptUrl, item.urlType) ? 'div' : 'a')
              "
              :to="
                isInternalRoute(item.mvmnptUrl, item.urlType)
                  ? getInternalPath(item.mvmnptUrl, item.urlType)
                  : undefined
              "
              :href="
                isInternalRoute(item.mvmnptUrl, item.urlType) || isPlaceholderExternal(item.mvmnptUrl, item.urlType)
                  ? undefined
                  : getExternalUrl(item.mvmnptUrl, item.urlType)
              "
              :class="[
                'banner-slide-link',
                {
                  'external-link': !isInternalRoute(item.mvmnptUrl, item.urlType) && !isPlaceholderExternal(item.mvmnptUrl, item.urlType),
                },
              ]"
              :title="
                isInternalRoute(item.mvmnptUrl, item.urlType) || isPlaceholderExternal(item.mvmnptUrl, item.urlType)
                  ? undefined
                  : '새창으로 바로가기'
              "
              :target="
                isInternalRoute(item.mvmnptUrl, item.urlType) || isPlaceholderExternal(item.mvmnptUrl, item.urlType)
                  ? undefined
                  : '_blank'
              "
              
            >
              <div class="banner-slide-content">
                <div class="banner-image">
                  <img
                    :src="getSafeImageUrl(item.moImgPtUrl)"
                    :alt="item.bannrTit || 'Banner'"
                  />
                </div>
              </div>
            </component>
            <!-- 링크가 없는 경우를 위한 대체 div -->
            <div v-if="!item.mvmnptUrl" class="banner-slide-content">
              <div class="banner-image">
                <img
                  :src="getSafeImageUrl(item.moImgPtUrl)"
                  :alt="item.bannrTit || 'Banner'"
                />
              </div>
            </div>
          </div>
        </div>
        <!-- 컨트롤 버튼 -->
        <div v-if="banners.length > 1" class="swiper-controls">
          <button
            type="button"
            class="swiper-button-prev"
            :disabled="!isSwiperReady"
            @click="goToPrevSlide"
          >
            이전
          </button>
          <button
            type="button"
            class="swiper-button-next"
            :disabled="!isSwiperReady"
            @click="goToNextSlide"
          >
            다음
          </button>
        </div>
        <div v-if="banners.length > 1" class="swiper-pagination"></div>
        <!-- 페이지네이션 및 재생/정지 버튼 -->
        <!-- <div class="pagination-control-group">
          <div class="swiper-pagination"></div>
          <button
            type="button"
            class="btn-pause"
            :disabled="!isSwiperReady"
            @click="togglePlay"
          >
            <span class="icon">
              <svg v-if="playing" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none" class="pc-block">
                <mask id="path-1-inside-1_462_2866" fill="white">
                <path d="M0 0H40V40H0V0Z"/>
                </mask>
                <path d="M0 0H40V40H0V0Z" fill="white"/>
                <path d="M0 0V-1H-1V0H0ZM0 40H-1V41H0V40ZM0 0V1H40V0V-1H0V0ZM40 40V39H0V40V41H40V40ZM0 40H1V0H0H-1V40H0Z" fill="#C6C6C6" mask="url(#path-1-inside-1_462_2866)"/>
                <path d="M16.6621 14V26" stroke="#1D1D1D" stroke-width="1.6" stroke-linecap="square" stroke-linejoin="round"/>
                <path d="M23.3301 14V26" stroke="#1D1D1D" stroke-width="1.6" stroke-linecap="square" stroke-linejoin="round"/>
              </svg>
              <svg v-else xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none" class="pc-block">
                <mask id="path-1-inside-1_490_533" fill="white">
                <path d="M0 0H40V40H0V0Z"/>
                </mask>
                <path d="M0 0H40V40H0V0Z" fill="white"/>
                <path d="M0 0V-1H-1V0H0ZM0 40H-1V41H0V40ZM0 0V1H40V0V-1H0V0ZM40 40V39H0V40V41H40V40ZM0 40H1V0H0H-1V40H0Z" fill="#C6C6C6" mask="url(#path-1-inside-1_490_533)"/>
                <path d="M24.883 20.0819L15.1573 26.8899C15.0911 26.9363 15 26.8888 15 26.8079L15 13.1921C15 13.1112 15.0911 13.0637 15.1573 13.1101L24.883 19.9181C24.9398 19.9579 24.9398 20.0421 24.883 20.0819Z" stroke="#1D1D1D" stroke-width="1.6" stroke-linecap="round"/>
              </svg>
              <svg
                v-if="playing"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="m-block"
              >
                <rect
                  width="24"
                  height="24"
                  rx="12"
                  fill="#008475"
                  style="
                    fill: #008475;
                    fill: color(display-p3 0 0.5193 0.4587);
                    fill-opacity: 1;
                  "
                />
                <path
                  d="M9 7.5V16.5"
                  stroke="white"
                  style="stroke: white; stroke-opacity: 1"
                  stroke-width="2"
                  stroke-linecap="round"
                />
                <path
                  d="M15 7.5V16.5"
                  stroke="white"
                  style="stroke: white; stroke-opacity: 1"
                  stroke-width="2"
                  stroke-linecap="round"
                />
              </svg>
              <svg
                v-else
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="m-block"
              >
                <rect
                  width="24"
                  height="24"
                  rx="12"
                  fill="#008475"
                  style="
                    fill: #008475;
                    fill: color(display-p3 0 0.5193 0.4587);
                    fill-opacity: 1;
                  "
                />
                <path
                  d="M16.7333 12.2L9.4 17.7C9.23519 17.8236 9 17.706 9 17.5L9 6.5C9 6.29399 9.23519 6.17639 9.4 6.3L16.7333 11.8C16.8667 11.9 16.8667 12.1 16.7333 12.2Z"
                  stroke="white"
                  style="stroke: white; stroke-opacity: 1"
                  stroke-width="2"
                  stroke-linecap="round"
                />
              </svg>
            </span>
          </button>
        </div> -->
      </div>
      <div v-else class="banner-loading">
        <!-- <p>배너 로딩 중...</p> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { ACT_GET_BANNER_LIST } from "../store/_act_consts";
import { getCheckItems } from "../assets/js/utils";
import {
  MUT_SET_BANNERS,
  MUT_SET_LAST_BANNER_INDEX,
  MUT_SHOW_ALERT,
} from "../store/_mut_consts";
import Swiper from "swiper";

// 내부 라우트 정의 (실제 프로젝트 구조에 맞게 조정 필요)
const routes = [
  {
    path: "/",
    component: "MainLayout",
    children: [
      { path: "", name: "Main", component: "Main" },
      { path: "/ko", name: "SubMain", component: "Main" },
      {
        path: "/ko/info",
        name: "Information",
        meta: { title: "동행축제 > 행사정보" },
      },
      {
        path: "/ko/info/history",
        name: "InformationHistory",
        meta: { title: "동행축제 > 행사연혁" },
      },
      {
        path: "/ko/promotion",
        name: "Promotion",
        meta: { title: "동행축제 > 홍보물" },
      },
      // {
      //   path: "/ko/exhibition",
      //   name: "ExhibitionPublish",
      //   meta: { title: "상생할인전" },
      // },
      { path: "/ko/festival", name: "Festival", meta: { title: "지역행사" } },
      { path: '/ko/festival2', name: 'Festival2', meta: { title: '지역행사2' } },
      {
        path: "/ko/event/check_publish",
        name: "EventCheck",
        meta: { title: "이벤트 > 출석체크" },
      },
      {
        path: "/ko/event/dibs",
        name: "EventDibs",
        meta: { title: "이벤트 > 찜하기" },
      },
      {
        path: "/ko/event/sns",
        name: "EventSns",
        meta: { title: "이벤트 > 구매후기" },
      },
      { path: "/ko/news/list", name: "NewsList", meta: { title: "동행뉴스" } },
      {
        path: "/ko/news/:newsId",
        name: "NewsDetail",
        meta: { title: "동행뉴스" },
      },
      { path: "/ko/mypage", name: "Mypage", meta: { title: "마이페이지" } },
      {
        path: "/ko/privacy-policy",
        name: "PrivacyPolicy",
        meta: { title: "개인정보처리방침" },
      },
      { path: "/ko/policy", name: "Policy", meta: { title: "이용약관" } },
      {
        path: "/ko/info/campnHistory",
        name: "CampnHistory",
        meta: { title: "동행축제 > 행사연혁" },
      },
      {
        path: "/ko/exhibitionList",
        name: "Exhibition",
        meta: { title: "상생할인전" },
      },
      {
        path: "/ko/event/eatingOut",
        name: "EventEating",
        meta: { title: "이벤트 > 외식 활성화" },
      },
      {
        path: "/ko/event/dineOut",
        name: "EventDineOut",
        meta: { title: "이벤트 > 오늘 식사 한 끼, 밖에서 먹어요" },
      },
      {
        path: "/ko/event/check",
        name: "EventAttendanceCheck",
        meta: { title: "이벤트 > 출석체크" },
      },
      {
        path: "/ko/event/ranking",
        name: "EventRanking",
        meta: { title: "이벤트 > 랭킹게임" },
      },
      {
        path: "/ko/event/delivery",
        name: "EventDelivery",
        meta: { title: "이벤트 > 공공배달앱 이용후기" },
      },
      {
        path: "/ko/event/challenge",
        name: "EventChallenge",
        meta: { title: "이벤트 > 동행 숨결 챌린지" },
      },
      {
        path: "/ko/products/category",
        name: "ProductsCategory",
        meta: { title: "동행제품 > 제품 카테고리" },
      },
      {
        path: "/ko/products/popular",
        name: "ProductsPopular",
        meta: { title: "동행제품 > 인기제품" },
      },
      {
        path: "/ko/event/kakaoFriend",
        name: "EventKakaoFriend",
        meta: { title: "이벤트 > 카카오톡 친구추가 이벤트" },
      },
      {
        path: "/ko/event/giftCertificate",
        name: "EventGiftCertificate",
        meta: { title: "이벤트 > 지역사랑상품권 이벤트" },
      },
      { path: "/ko/onair", name: "OnAir", meta: { title: "온에어쇼핑" } },
      {
        path: '/ko/event/LastWinPage',
        name: 'EventLastWinPage',
        meta: { title: "이벤트 > 지난 이벤트 당첨결과" },
      },
    ],
  },
  {
    path: "/",
    component: "LoginLayout",
    children: [
      { path: "login", name: "Login", component: "Login" },
      { path: "signup", name: "Signup", component: "Signup" },
      { path: "findInfo/:division", name: "FindInfo", component: "FindInfo" },
    ],
  },
  {
    path: "/",
    component: "EngLayout",
    children: [
      {
        path: "/en",
        name: "English Main",
        meta: { title: "Korea Shopping Festa" },
      },
      {
        path: "/en/event",
        name: "Event Guide",
        meta: { title: "Korea Shopping Festa" },
      },
      {
        path: "/en/products",
        name: "Featured Products",
        meta: { title: "Korea Shopping Festa" },
      },
    ],
  },
  { path: "/:pathMatch(.*)*", name: "NotFound", component: "NotFound" },
];

export default {
  name: "Banner",
  data: () => ({
    swiperInstance: null,
    activeSlideIndex: 0,
    playing: true,
    isSwiperReady: false,
    swiperOptions: {
      /* slidesPerView: 1,
      centeredSlides: true, */
      watchOverflow: true,
      spaceBetween: 0,
      loop: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".swiper-pagination",
        /* type: "fraction", */
      },
      breakpoints: {
        /* 0: {
          slidesPerView: 1,
          centeredSlides: true,
          spaceBetween: 0,
        },
        576: {
          slidesPerView: 1,
          centeredSlides: true,
          spaceBetween: 30,
        },
        768: {
          slidesPerView: 1,
          centeredSlides: true,
          spaceBetween: 40,
        },
        901: {
          slidesPerView: 2,
          centeredSlides: false,
          spaceBetween: 20,
        }
        1024: {
          slidesPerView: 1.1,
          centeredSlides: true,
          spaceBetween: 50,
        }, */
        0: {
          slidesPerView: 1,
          spaceBetween: 0,
          pagination: {
            el: ".swiper-pagination",
              type: "bullets",
          },
        },
        901: {
          slidesPerView: 2,
          spaceBetween: 0,
          loopAdditionalSlides: 1,
          /* pagination: {
            el: ".swiper-pagination",
              type: "custom",
              renderCustom: function (swiper, current, total) {
                const fillPer = (current / total) * 100;
                const fillWidth = fillPer + '%;';
                return '<div class="progress__bar" style="margin-right:16px; width:calc(100% - 200px); height:4px; background:#E4E4E4;"><span class="progress__fill" style="width:' + fillWidth + '; display:block; height: 4px; background:#006F45; transition: width 0.3s ease;"></span></div><span class="current" style="margin-right:4px; font-size:18px; color:#006F45; font-weight:600;">' + current + '</span><span style="font-size:18px; color:#1d1d1d; font-weight:500;">/ ' + total + '</span>';
            },
          }, */
        },
        1161: {
          slidesPerView: 3,
        }
      },
    },
  }),
  computed: {
    ...mapGetters("main", ["bannerExpired", "lastBannerIndex"]),
    banners() {
      return [
        {
          moImgPtUrl: require('@/assets/img/event/banner0108.png'),
          mvmnptUrl: '/ko/event/delivery',
          urlType: '1',
          bannrTit: '이벤트 당첨자 발표'
        }
      ];
    }
  },
  watch: {
    banners(newBanners) {
      if (newBanners && newBanners.length > 0) {
        this.$nextTick(() => {
          if (this.swiperInstance && !this.swiperInstance.destroyed) {
            this.swiperInstance.update();
          } else {
            this.initializeSwiper();
          }
        });
      } else if (this.swiperInstance && !this.swiperInstance.destroyed) {
        this.swiperInstance.destroy(true, true);
        this.swiperInstance = null;
        this.isSwiperReady = false;
      }
    },
  },
  async created() {
    if (
      !this.banners ||
      this.banners.length === 0 ||
      new Date().getDate() > this.bannerExpired
    ) {
      try {
        const res = await this.getBannerList();
        const bannerItems = getCheckItems(res);
        if (Array.isArray(bannerItems)) {
          await this.$store.commit(`main/${MUT_SET_BANNERS}`, bannerItems);
        } else {
          console.error("[Banner] Invalid banner items received:", res);
          await this.$store.commit(`main/${MUT_SET_BANNERS}`, []);
        }
      } catch (error) {
        console.error(
          "[Banner] Error fetching banner list in created hook:",
          error
        );
        await this.$store.commit(`main/${MUT_SET_BANNERS}`, []);
      }
    } else {
      console.log("[Banner] Using existing banner data from store.");
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initializeSwiper();
    });
  },
  beforeDestroy() {
    if (this.swiperInstance && !this.swiperInstance.destroyed) {
      try {
        const currentIndex =
          this.swiperInstance.realIndex !== undefined
            ? this.swiperInstance.realIndex
            : this.swiperInstance.activeIndex;
        if (currentIndex >= 0) {
          // --- 뮤테이션 호출 수정: $store.commit 사용 ---
          this.$store.commit(`main/${MUT_SET_LAST_BANNER_INDEX}`, currentIndex);
        }
        this.swiperInstance.destroy(true, true);
        this.swiperInstance = null;
        this.isSwiperReady = false;
      } catch (error) {
        console.error("[Banner] Error during beforeDestroy:", error);
      }
    }
  },
  methods: {
    // mapMutations 제거 (직접 commit 사용)
    // ...mapMutations("main", [MUT_SET_BANNERS, MUT_SET_LAST_BANNER_INDEX]),

    getBannerList() {
      return this.$store.dispatch(`main/${ACT_GET_BANNER_LIST}`);
    },
    async initializeSwiper() {
      if (
        !this.banners ||
        this.banners.length === 0 ||
        !this.$refs.bannerSwiper ||
        this.swiperInstance
      ) {
        return;
      }

      let newInstance = null;

      // 배너 개수에 맞춰 옵션 조정
      const bannerCount = this.banners.length;
      const swiperParams = JSON.parse(JSON.stringify(this.swiperOptions));

      if (bannerCount === 1) {
        swiperParams.loop = false;
        swiperParams.autoplay = false;
      }

      try {
        if (!(this.$refs.bannerSwiper instanceof HTMLElement)) {
          throw new Error("bannerSwiper ref is not a valid HTMLElement");
        }

        newInstance = new Swiper(this.$refs.bannerSwiper, {
          ...swiperParams,
          on: {
            slideChange: () => {
              if (this.swiperInstance && !this.swiperInstance.destroyed) {
                const currentIndex =
                  this.swiperInstance.realIndex !== undefined
                    ? this.swiperInstance.realIndex
                    : this.swiperInstance.activeIndex;
                this.activeSlideIndex = currentIndex;
              }
            },
            click: (e) => {
              this.onSwiperClick(this.swiperInstance || newInstance, e);
            },
            init: () => {
              console.log("[Banner] Swiper init callback executed.");
            },
            autoplayStop: () => {
              if (this.swiperInstance && !this.swiperInstance.destroyed) {
                console.log("[Banner] Autoplay stopped");
              }
            },
            autoplayStart: () => {
              if (this.swiperInstance && !this.swiperInstance.destroyed) {
                console.log("[Banner] Autoplay started");
              }
            },
            slideChangeTransitionEnd: () => {
              if (this.swiperInstance && !this.swiperInstance.destroyed) {
                const currentRealIndex =
                  this.swiperInstance.realIndex !== undefined
                    ? this.swiperInstance.realIndex
                    : this.swiperInstance.activeIndex;
                this.activeSlideIndex = currentRealIndex;
                // --- 슬라이드 변경 시에도 인덱스 저장 ---
                if (currentRealIndex >= 0) {
                  this.$store.commit(
                    `main/${MUT_SET_LAST_BANNER_INDEX}`,
                    currentRealIndex
                  );
                }
              }
            },
          },
        });

        if (!newInstance || newInstance.destroyed) {
          throw new Error("Failed to create a valid Swiper instance");
        }

        this.swiperInstance = newInstance;

        await this.$nextTick();

        if (this.swiperInstance && !this.swiperInstance.destroyed) {
          this.isSwiperReady = true;

          // --- 로깅 추가: 스토어에서 읽어온 값 확인 ---

          const targetIndex = this.lastBannerIndex;
          let shouldStartAutoplay = this.playing;

          const initialIndex =
            this.swiperInstance.realIndex !== undefined
              ? this.swiperInstance.realIndex
              : this.swiperInstance.activeIndex;

          // --- 로깅 추가: 복원 조건 확인 ---

          if (
            targetIndex >= 0 &&
            targetIndex < this.banners.length &&
            targetIndex !== initialIndex
          ) {
            try {
              if (this.swiperOptions.loop) {
                if (typeof this.swiperInstance.slideToLoop === "function") {
                  this.swiperInstance.slideToLoop(targetIndex, 0, false);
                } else {
                  console.error("[Banner] slideToLoop not found");
                }
              } else {
                if (typeof this.swiperInstance.slideTo === "function") {
                  this.swiperInstance.slideTo(targetIndex, 0, false);
                } else {
                  console.error("[Banner] slideTo not found");
                }
              }
              this.activeSlideIndex = targetIndex;
            } catch (slideError) {
              console.error(
                `[Banner] Error during slideTo/Loop AFTER nextTick:`,
                slideError
              );
              this.activeSlideIndex = initialIndex;
            }
          } else {
            this.activeSlideIndex = initialIndex;
          }

          if (shouldStartAutoplay && this.swiperInstance.autoplay) {
            if (!this.swiperInstance.autoplay.running) {
              this.swiperInstance.autoplay.start();
            } else {
              console.log("[Banner] Autoplay already running AFTER nextTick.");
            }
          } else if (shouldStartAutoplay) {
            console.warn(
              "[Banner] Autoplay could not be started AFTER nextTick."
            );
          }
        } else {
          console.error(
            "[Banner] Swiper instance became invalid before operations in nextTick."
          );
          this.isSwiperReady = false;
        }
      } catch (error) {
        console.error("[Banner] Failed to initialize Swiper:", error);
        this.isSwiperReady = false;
        if (this.swiperInstance) {
          try {
            this.swiperInstance.destroy(true, true);
          } catch (e) {}
          this.swiperInstance = null;
        } else if (newInstance) {
          try {
            newInstance.destroy(true, true);
          } catch (e) {}
        }
      }
    },
    handleBannerClick(index, event) {
      let currentIndex = index;
      if (this.swiperInstance && !this.swiperInstance.destroyed) {
        currentIndex =
          this.swiperInstance.realIndex !== undefined
            ? this.swiperInstance.realIndex
            : this.swiperInstance.activeIndex;
      }

      if (currentIndex >= 0) {
        // --- 뮤테이션 호출 수정: $store.commit 사용 ---
        this.$store.commit(`main/${MUT_SET_LAST_BANNER_INDEX}`, currentIndex);
      } else {
        console.warn(
          `[Banner] Could not determine valid index on click. Clicked index: ${index}`
        );
      }
      // 이 핸들러는 원본 슬라이드에서만 보조적으로 사용. 핵심 클릭 처리는 onSwiperClick에서 위임 처리합니다.
    },
    onSwiperClick(swiper, event) {
      try {
        if (!swiper) return;
        const slideEl = swiper.clickedSlide || (event && event.target && event.target.closest ? event.target.closest('.swiper-slide') : null);
        if (!slideEl) return;
        let realIdx;
        const attr = slideEl.getAttribute && slideEl.getAttribute('data-swiper-slide-index');
        if (attr != null) {
          const parsed = parseInt(attr, 10);
          if (!isNaN(parsed)) realIdx = parsed;
        }
        if (realIdx == null) {
          const ci = typeof swiper.clickedIndex === 'number' ? swiper.clickedIndex : -1;
          realIdx = (ci >= 0 && this.banners && this.banners.length > 0)
            ? (ci % this.banners.length)
            : this.activeSlideIndex;
        }
        if (realIdx == null || realIdx < 0 || !this.banners || !this.banners[realIdx]) return;
        const item = this.banners[realIdx];
        const url = item && item.mvmnptUrl;
        const isInternal = this.isInternalRoute(url, item && item.urlType);
        const isPlaceholder = this.isPlaceholderExternal(url, item && item.urlType);

        // 외부 정상 URL: 앵커 기본 동작에 맡김
        if (!isInternal && !isPlaceholder) {
          return;
        }
        // 인덱스 저장은 내부/자리표시자에서만 수행
        if (typeof realIdx === 'number' && realIdx >= 0) {
          this.$store.commit(`main/${MUT_SET_LAST_BANNER_INDEX}`, realIdx);
        }
        if (isPlaceholder) {
          if (event && typeof event.preventDefault === 'function') event.preventDefault();
          if (event && typeof event.stopPropagation === 'function') event.stopPropagation();
          this.$store.commit(`common/${MUT_SHOW_ALERT}`, { title: '준비중입니다.', rightNow: true });
          return;
        }
        if (isInternal) {
          if (event && typeof event.preventDefault === 'function') event.preventDefault();
          if (event && typeof event.stopPropagation === 'function') event.stopPropagation();
          const path = this.getInternalPath(url, item && item.urlType);
          this.$router.push(path);
          return;
        }
      } catch (e) {
        console.error('[MobileBanner] onSwiperClick error:', e);
      }
    },
    togglePlay() {
      if (
        !this.swiperInstance ||
        this.swiperInstance.destroyed ||
        !this.swiperInstance.autoplay
      ) {
        console.error(
          "[Banner] Swiper instance or autoplay module is not available or destroyed."
        );
        return;
      }
      this.playing = !this.playing;
      if (this.playing) {
        this.swiperInstance.autoplay.start();
      } else {
        this.swiperInstance.autoplay.stop();
      }
    },
    goToPrevSlide() {
      if (this.swiperInstance && !this.swiperInstance.destroyed) {
        this.swiperInstance.slidePrev();
      }
    },
    goToNextSlide() {
      if (this.swiperInstance && !this.swiperInstance.destroyed) {
        this.swiperInstance.slideNext();
      }
    },
    goToSlide(index) {
      if (this.swiperInstance && !this.swiperInstance.destroyed) {
        if (this.swiperOptions.loop) {
          this.swiperInstance.slideToLoop(index);
        } else {
          this.swiperInstance.slideTo(index);
        }
      }
    },
    getSafeImageUrl(url) {
      try {
        if (!url) return "/assets/default-banner.png";
        // require()로 가져온 데이터나 이미 http로 시작하는 경우 그대로 반환
        if (typeof url === 'string' && (url.startsWith("http") || url.startsWith("data:") || url.startsWith("/"))) {
          return url;
        }
        return url; // require() 결과물(base64 또는 경로)인 경우 그대로 반환
      } catch (e) {
        console.error(`[MobileBanner] Failed to load image:`, e);
        return '/assets/default-banner.png';
      }
    },
    isInternalRoute(url, type) {
      if (!url) return false;
      // urlType이 1이면 내부 링크로 간주합니다.
      return type == 1 || type == '1';
    },
    getInternalPath(url, type) {
      if (!url) return undefined;
      if (type == 1 || type == "1") {
        try {
          const parsedUrl = new URL(url, window.location.origin);
          return parsedUrl.pathname + parsedUrl.search + parsedUrl.hash;
        } catch (e) {
          return url.startsWith("/") ? url : `/${url}`;
        }
      }
    },
    getExternalUrl(url, type) {
      if (!url) return "#";
      if (type == 2 || type == "2") {
        if (/^(https?:\/\/|\/\/)/i.test(url)) {
          return url;
        }
        if (!url.startsWith("/") && url.includes(".")) {
          return `//${url}`;
        }
        console.warn(
          `[getExternalUrl] Assuming non-HTTP URL or keeping as is: ${url}`
        );
        return url;
      }
    },
    isPlaceholderExternal(url, type) {
      if (this.isInternalRoute(url, type)) return false;
      if (!url) return true;
      const s = String(url).trim();
      return s === 'https://';
    },
  },
};
</script>

<style scoped>
[class*="-component"] {
  position: relative;
  margin: auto;
  padding: 0;
}
.m-block {display:none;}
.pc-block {display:block;}
@font-face {
	font-family: 'Gmarket Sans';
	font-weight: 700;
	font-display: swap;
	src: url('../assets/fonts/woff2/GmarketSansBold.woff2') format('woff2'), url('../assets/fonts/woff/GmarketSansBold.woff') format('woff');
}

@font-face {
	font-family: 'Gmarket Sans';
	font-weight: 400;
	font-display: swap;
	src: url('../assets/fonts/woff2/GmarketSansMedium.woff2') format('woff2'), url('../assets/fonts/woff/GmarketSansMedium.woff') format('woff');
}
.main-banner {
  position: relative;
  width: 100%;
  overflow: hidden; /* ✅ 다른 슬라이드 보이지 않게 */
  padding: 0;
  margin: 0;
}
.main-banner .banner-title {
  display:flex;
  justify-content:flex-end;
  margin: 0 auto;
  padding:0 24px 14px;
  width:100%;
  max-width:1328px;
  font-family: 'Gmarket Sans';
  text-indent:10px;
  letter-spacing: -0.02em;
  line-height: 1.2;
  font-size: 21px;
  color: #555;
}
.main-banner .banner-title strong {
  color: #006F45;
  font-weight: 700;
}
.banner-wrapper {
  position: relative;
  max-width: 1328px;
  width: 100%;
  margin: 0 auto;
  padding: 0 24px;
}
/* 슬라이더 */
.banner-component {
  width: 100%;
  overflow: hidden; /* ✅ 이중 안전장치 */
}
.banner-slide-link {
  width:100%;
  height:100%;
}
.banner-slide-content {
  height: 100%;
}
.swiper-slide {
  display: flex;
  justify-content: center;
  align-items: center;
  transition: transform 0.3s ease;
  aspect-ratio: 427/411;
}

/* 배너가 1개일 때 전체 너비를 차지하도록 수정 */
.banner-count-1 .swiper-slide {
  width: 100% !important;
  max-width: 100% !important;
  aspect-ratio: 1278/480; /* PC와 동일한 비율 유지 또는 모바일에 최적화된 비율 */
}
/* 슬라이드 콘텐츠 */
.banner-slide-content {
  width: 100%;
  height: 100%;
  border-radius: 0;
  box-shadow: none;
}

/* 이미지 박스 */
.banner-image {
  width: 100%;
  height: 100%;
}

/* 이미지 자체 */
.banner-image img {
  display: block;
  width: 100%;
  height:100%;
  /* height: 280px; */
  object-fit: cover;
  border-radius: 0;
}

.banner-image img {
  display: block;
  width: 100%;
/*   max-width: 1280px; */
  object-fit: cover;
}
.swiper-controls {
  position: absolute;
  /* bottom: 0; */
  right: 0;
  top:calc(50% - 25px);
  width:100%;
  height:50px;
  z-index: 20;
  display: flex;
  justify-content: space-between;
  pointer-events: none;
}
.swiper-button-prev,
.swiper-button-next {
  top:initial;
  bottom:0;
  pointer-events: auto;
  width: 50px;
  height: 50px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  text-indent:-9999px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.swiper-button-prev {
  left: 0;
  background:url("../assets/img/main/btn-swiper-prev.svg") no-repeat center;
}

.swiper-button-next {
  right: 0;
  background:url("../assets/img/main/btn-swiper-next.svg") no-repeat center;
}

/* pagination + pause 버튼 나란히 정렬 */
.pagination-control-group {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
}

.swiper-pagination {
  position: initial;
  display:flex;
  justify-content: center;
  align-items: center;
  width:100%;
  height:40px;
}
.swiper-pagination-lock {
  display: none !important;
}
.btn-pause {
  position:absolute;
  right:40px;
  bottom:0;
  z-index: 21;
  width: 40px;
  height: 40px;
  border-top: 1px solid #C6C6C6;
  border-bottom: 1px solid #C6C6C6;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
:deep(.swiper-pagination-fraction) {
  font-size: 14px;
  color: #555;
  width: auto;
}

:deep(.swiper-pagination-current) {
  font-weight: 700;
  color: #008475;
}
/* .swiper-slide-prev .banner-slide-content,
.swiper-slide-next .banner-slide-content {
  opacity: 0.6;
} */
@media(max-width:1494px) {
  .main-banner .banner-title {
    padding-top: 14px;
  }
}
@media(max-width:900px){
  .m-block {display:block;}
  .pc-block {display:none;}
  .main-banner .banner-title {
    display:none;
  }
  .banner-wrapper {
    padding: 0;
  }
  .swiper-pagination {
    width:auto;
    height:36px;
  }
  .swiper-controls {
    top:calc(50% - 18px);
    left:16px;
    width:calc(100% - 32px);
    height:36px;
  }
  .pagination-control-group {
    gap:4px;
    justify-content:center;
    margin-top:8px;
  }
  .swiper-button-prev,
  .swiper-button-next {
    width:36px;
    height:36px;
    border-radius: 50%;
  }
  .btn-pause {
    position:initial;
    border:none;
    min-width:36px;
    height:36px;
  }
}
/* @media(max-width:375px) {
  .main-banner .swiper-slide {
    aspect-ratio: 371/278;
  }
} */
</style>
